var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor terminate-automation" },
    [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(
              _vm._s(_vm.$t("auto.terminateAutomationTerminateWithSuccess"))
            ),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            model: {
              value: _vm.clone.success,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "success", $$v)
              },
              expression: "clone.success",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.clone.success
        ? _c(
            "div",
            { staticClass: "editor-row customize-editor-minimize" },
            [
              _c("div", { staticClass: "editor-row-title" }, [
                _vm._v(_vm._s(_vm.$t("auto.terminateAutomationFailReason"))),
              ]),
              _vm._v(" "),
              _c("TiptapEditor", {
                attrs: {
                  placeholder: "Fail Reason",
                  "show-attributes": true,
                  "max-character-count": 500,
                  "automation-mode": "",
                  previewMode: _vm.clone.success,
                },
                model: {
                  value: _vm.clone.failReason,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "failReason", $$v)
                  },
                  expression: "clone.failReason",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }